/**
 * Остання межа помилок над усім застосунком: якщо впав навіть роутер чи провайдери, людина бачить
 * «Інтерфейс зупинився через помилку» з перезавантаженням і зверненням, а не білий екран (UX-50).
 * Збої екранів і оболонки ловить роутер (`RouteError`, `RootError` у routes/root.tsx); сюди
 * доходить лише те, що поза ним. Форма звернення стоїть поза межею, тож відкривається й зі збою.
 */
import { Component, type ReactNode } from 'react';
import { NotifyHost } from '../ui/notify/NotifyHost.tsx';
import { ReportHost } from './ReportHost.tsx';
import { RootError } from './RootError.tsx';

interface State {
  failed: boolean;
  error: unknown;
}

export class RootBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { failed: false, error: null };
  static getDerivedStateFromError(error: unknown): State {
    return { failed: true, error };
  }
  override render() {
    return (
      <>
        {this.state.failed ? <RootError error={this.state.error} /> : this.props.children}
        <ReportHost />
        {/* Тости поза межею: тост «форма не відкрилась» видно й на екрані RootError. */}
        <NotifyHost />
      </>
    );
  }
}
